import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/PageBanner/PageBanner.js
const PageBanner = createSectionForm({
  icon: "layout-top-line",
  title: "Page Banner",
  fields: [
    { name: "outline_heading", label: "Outline Heading", placeholder: "About Us" },
    { name: "title", label: "Title" },
    { name: "description", label: "Description", type: "richtext" },
    { name: "image", label: "Image", type: "media" },
  ],
});

export default PageBanner;
